import { render } from "./CardSecretBuy.vue?vue&type=template&id=f50fb3d6&scoped=true"
import script from "./CardSecretBuy.vue?vue&type=script&lang=js"
export * from "./CardSecretBuy.vue?vue&type=script&lang=js"

import "./CardSecretBuy.vue?vue&type=style&index=0&id=f50fb3d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f50fb3d6"]])

export default __exports__